import axios from '@/utils/request';

function RULE(params) {
    return axios.get("/kshadmin/PanelRole/rule", {
        params: params
    })
}

function RULE_POST(params) {
    return axios.post("/kshadmin/PanelRole/rulePost", {
        ...params
    })
}

export default {
    RULE,
    RULE_POST
};